import {getListCounts} from "./general/catalog";

export default function initFlyout() {
    const _ = [     //trustedOrigins -> not used
        'http://localhost:9000',
        'http://wilo-com.wilo.hq.arithnea.de',
        'https://wilo-com.wilo-websites.com',
        'https://wilo.com'
    ];

    document.addEventListener("DOMContentLoaded", event => {
        const flyout = document.querySelector('.flyout');
        const SCROLLDELAY = 15;

        function readListCounts() {
            // console.log(event.origin);
            //if (trustedOrigins.indexOf(event.origin) == -1) return;

            const counts = getListCounts(wiloconfig.amirada.country, localStorage);
            Object.entries(counts).forEach(([key, count]) => {
                flyout.querySelectorAll(`[data-flyout="${key}"]`).forEach((el) => {
                    if (count > 0) {
                        el.querySelector("[data-badge]")?.setAttribute("data-badge", count.toString());
                    }
                });
            });
        }
        
        function windowNotScrollable() {
            return document.querySelector('html').scrollHeight == document.querySelector('html').clientHeight;
        }
            
        function debounce(fn, delay) {
            clearTimeout(fn._tId);
            fn._tId = window.setTimeout(fn, delay);
        }

        if (!!flyout) {
            window.addEventListener("scroll", event => {
                //if (trustedOrigins.indexOf(event.origin) == -1) return;
            
                debounce(() => {
                    if (flyout.getAttribute('data-visible-forced') != "true") {
                        flyout.setAttribute('data-visible', window.pageYOffset > SCROLLDELAY);
                    }
                }, 50);
            });

            window.addEventListener('resize', event => {
                //if (trustedOrigins.indexOf(event.origin) == -1) return;

                debounce(() => {
                    if (windowNotScrollable()) {
                        flyout.setAttribute('data-visible-forced', true);
                        flyout.setAttribute('data-visible', true);
                    } else {
                        flyout.setAttribute('data-visible-forced', false);
                        flyout.setAttribute('data-visible', window.pageYOffset > SCROLLDELAY);
                    }
                }, 50);
            });
    
            window.addEventListener("listCountChanged", readListCounts);
            
            flyout.querySelector('button').addEventListener('click', event => {
                event.preventDefault();
                flyout.setAttribute('data-visible-forced', true);
                flyout.setAttribute('data-visible', flyout.getAttribute('data-visible') != "true");
            });

            readListCounts();

            if (windowNotScrollable()) {
                flyout.setAttribute('data-visible-forced', true);
                flyout.setAttribute('data-visible', true);
            } else {
                flyout.setAttribute('data-visible', window.pageYOffset > SCROLLDELAY);
            }
        }        
    });
};